import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function PositioningSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-dark relative overflow-hidden border-t border-brand-gold/10" data-id="element-85">
      {/* Decorative background lines */}
      <div className="absolute inset-0 opacity-5" data-id="element-86">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-87">
          <defs data-id="element-88">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-89">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#C8952B" strokeWidth="1" data-id="element-90" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-91" />
        </svg>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-93">
          <div className="flex justify-center mb-6" data-id="element-94">
            <div className="w-16 h-16 bg-brand-white border border-brand-gold rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(200,149,43,0.3)]" data-id="element-95">
              <ShieldIcon className="w-8 h-8 text-brand-gold" data-id="element-96" />
            </div>
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-5xl uppercase tracking-tight text-brand-text mb-5" data-id="element-97">
            Reclutas Digitales está{' '}
            <span className="text-brand-gold" data-id="element-98">enichado en seguros</span>
          </h2>

          <p className="text-lg md:text-xl text-brand-text-muted leading-relaxed mb-8 max-w-3xl mx-auto" data-id="element-99">
            Conocemos el negocio desde dentro: agentes, agencias, FMOs,
            overrides, AEP, chargebacks, seguimiento, activación y retención. No
            adaptamos fórmulas genéricas. Construimos una arquitectura pensada
            para el mercado hispano de seguros.
          </p>

          <a href="https://www.skool.com/reclutas-digitales-4277/about" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-gradient-to-r from-brand-gold to-brand-gold-bright text-brand-black font-heading font-bold uppercase tracking-wide rounded-md hover:shadow-[0_0_20px_rgba(232,184,74,0.4)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-100">
            ENTRAR A SKOOL
          </a>
        </motion.div>
      </div>
    </section>;
}